export default "__VITE_ASSET__BoDnqvnC__"